import React from 'react';


class TestFlask extends React.Component{

    constructor(props){
        super(props)
        this.state = {time:0, img:false}
        this.fetchTime.bind(this)
    }

    
    fetchTime () {
        const data = new FormData();
        data.append('time',0)
        data.append('name','challenge2016');
        fetch('/api/time',
        {
            method: 'post',
            headers: {"Accept": "application/text"},
            mode: 'same-origin',
            body: data
        }).then (response => {
            if (response.ok) {
            response.json().then((r) => {
                console.log(r)
                if ('time' in r)
                    this.setState({time:r['time'],
                                    img:r['img']})
            })
            }
        }).catch ( e => {
            console.log(e)
            this.setState({time:-1})
        }
        )
    }

    render() {
        return (
            <div style={{display:"flex"}}>
                <div>
                    <h2>Test flask api and base64 encoding for data transfer</h2>
                    <button className="btn btn-primary"
                        onClick={() => this.fetchTime()}>Fetch time and image</button>
                    <span style={{margin:"10px"}}>
                        Time = {this.state['time']}
                    </span>
                </div>
                <div>
                    {this.state.img ? <img src={`data:image/gif;base64,${this.state.img}`}/>: ''}
                </div>
            </div>
        )
    }
}

export default TestFlask;